import {
  Companion_instancek5x5ldr4ujbk as Companion_instance,
  System_instance34rnn1q53nv02 as System_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { nowLocal3kwskrm67145u as nowLocal } from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/ZonedDateTime.mjs';
import { todayIn1xeyw1nmvf0b4 as todayIn } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { Companion_getInstance13ujfby7pfhe7 as Companion_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lsKiteuiStarterClock() {
  _init_properties_clock_kt__gt341w();
  return lsKiteuiStarterClock;
}
var lsKiteuiStarterClock;
function get_TCG_TIME_ZONE() {
  _init_properties_clock_kt__gt341w();
  return TCG_TIME_ZONE;
}
var TCG_TIME_ZONE;
function now() {
  _init_properties_clock_kt__gt341w();
  return get_lsKiteuiStarter(Companion_instance).now_2cba_k$();
}
function get_lsKiteuiStarter(_this__u8e3s4) {
  _init_properties_clock_kt__gt341w();
  return get_lsKiteuiStarterClock();
}
function nowLocal_0() {
  _init_properties_clock_kt__gt341w();
  return nowLocal(get_lsKiteuiStarter(Companion_instance));
}
function today() {
  _init_properties_clock_kt__gt341w();
  return todayIn(get_lsKiteuiStarter(Companion_instance), get_TCG_TIME_ZONE());
}
var properties_initialized_clock_kt_whb7ku;
function _init_properties_clock_kt__gt341w() {
  if (!properties_initialized_clock_kt_whb7ku) {
    properties_initialized_clock_kt_whb7ku = true;
    lsKiteuiStarterClock = System_instance;
    TCG_TIME_ZONE = Companion_getInstance().of_5gnbr7_k$('America/New_York');
  }
}
//region block: exports
export {
  get_TCG_TIME_ZONE as get_TCG_TIME_ZONEb89pisv39t5w,
  nowLocal_0 as nowLocal2mdv5rmil2cf2,
  now as now2qufyxzn5e863,
  today as today1rno4frfjp5oe,
};
//endregion

//# sourceMappingURL=clock.mjs.map
